<template>
  <div>
    <jet-banner />
    <div class="min-h-screen bg-gray-100">
      <nav
        class="bg-white border-b border-gray-100">
        <!-- Primary Navigation Menu -->
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <!-- Logo -->
              <div class="flex items-center flex-shrink-0">
                <Link :href="route('dashboard')">
                  <jet-application-mark class="block w-auto h-9" />
                </Link>
              </div>

              <!-- Navigation Links -->
              <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                <jet-nav-link
                  :href="route('dashboard')"
                  :active="route().current('dashboard')">
                  ダッシュボード
                </jet-nav-link>
                <jet-nav-link
                  :href="route('questions', { subject: 1 })"
                  :active="route().current('questions')">
                  問題情報管理
                </jet-nav-link>
                <jet-nav-link
                  :href="route('examinations', { examination: 6 })"
                  :active="route().current('examinations')">
                  模試情報管理
                </jet-nav-link>
                <jet-nav-link
                  :href="route('analytics')"
                  :active="route().current('analytics')">
                  分析
                </jet-nav-link>
                <jet-nav-link
                  :href="route('information')"
                  :active="route().current('information')">
                  お知らせ管理
                </jet-nav-link>
                <jet-nav-link
                  :href="route('school')"
                  :active="route().current('school')">
                  学校管理
                </jet-nav-link>
                <!-- <jet-nav-link
                  :href="route('mail')"
                  :active="route().current('mail')">
                  メール配信
                </jet-nav-link> -->
                <!-- <jet-nav-link
                  :href="route('firebase')"
                  :active="route().current('firebase')">
                  Firebase連携
                </jet-nav-link> -->
              </div>
            </div>

            <div class="hidden sm:flex sm:items-center sm:ml-6">
              <!-- Settings Dropdown -->
              <div class="relative ml-3">
                <jet-dropdown
                  align="right"
                  width="48">
                  <template #trigger>
                    <span class="inline-flex rounded-md">
                      <button
                        type="button"
                        class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-transparent leading-4 rounded-md hover:text-gray-700 focus:outline-none transition">
                        {{ $page.props.user.name }}
                        <svg
                          class="ml-2 -mr-0.5 h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor">
                          <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>
                    </span>
                  </template>

                  <template #content>
                    <div class="block px-4 py-2 text-xs text-gray-400">
                      アカウント管理
                    </div>
                    <div class="border-t border-gray-100"></div>
                    <form @submit.prevent="logout">
                      <jet-dropdown-link as="button">
                        ログアウト
                      </jet-dropdown-link>
                    </form>
                  </template>
                </jet-dropdown>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <header
        v-if="$slots.header"
        class="bg-white shadow">
        <div class="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header>

      <!-- Page Content -->
      <main>
        <slot></slot>
        <flash-messages />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head, Link } from '@inertiajs/inertia-vue3'
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import FlashMessages from '@/Common/FlashMessages'

const props = defineProps(['title'])

const showingNavigationDropdown = ref(false)

const logout = () => Inertia.post(route('logout'))
</script>
